import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { base } from '../api-config';

import { StaffMember, StaffMemberRequest } from '../models/staff-member';

const endpoint = `${base}/staff_members`;

@Injectable({
  providedIn: 'root'
})
export class StaffMemberService {

  constructor(private http: HttpClient) {}

  get(id: number): Observable<StaffMember> {
    return this.http.get<StaffMember>(`${endpoint}/${id}`);
  }

  update(id: number, exam: StaffMemberRequest): Observable<StaffMember> {
    return this.http.put<StaffMember>(`${endpoint}/${id}`, exam);
  }

  delete(id: number): Observable<string> {
    return this.http.delete<string>(`${endpoint}/${id}`);
  }
}
